import { ExclusiveViewModel } from '@client/new/common/selfServeExclusive/exclusive.viewModel';
import { ExclusivePriceSetupProps } from '@client/new/common/selfServeExclusive/exclusivePriceSetup';
import { SalesType } from '@client/new/common/types';
import { _noop } from '@client/new/helpers/general';
import { GetInfluencerQuery } from 'generated/graphql';
import { Creator } from './exclusive.model';
import { Influencer } from '@playbook-technologies/common-enums';

export const toExclusiveSettingsView = (
  p: ExclusiveViewModel & { salesType?: SalesType },
): ExclusivePriceSetupProps & {
  errors?: string[];
  save: (callback?: () => void) => void;
  submitting: boolean;
  onHelpClick: (url: string) => void;
  hideSave: boolean;
} => {
  return {
    hideSave:
      p.readonly && p.price.monthlyInitialized && p.price.annualInitialized,
    readonly: p.readonly,
    errors: Object.values(p.errors)
      .map((error) => error.message)
      .filter(Boolean) as string[],
    save: (callback?: () => void) =>
      p.dispatch('saveExclusive', callback || _noop),
    submitting: p.submitting,
    monthly: {
      price: p.price.monthly,
      selected: p.price.monthlyEnabled,
      hasError: !!p.errors.subscriptionMonthlyPrice,
      changePrice: (value?: string) =>
        p.dispatch('setSubscriptionPrice', { type: 'monthly', price: value }),
      selectType: () => p.dispatch('enableSubscriptionPrice', 'monthly'),
      label: 'Monthly Subscription',
      initialized: p.price.monthlyInitialized,
    },
    annual: {
      price: p.price.annual,
      selected: p.price.annualEnabled,
      hasError: !!p.errors.subscriptionAnnualPrice,
      changePrice: (value?: string) =>
        p.dispatch('setSubscriptionPrice', { type: 'annual', price: value }),
      selectType: () => p.dispatch('enableSubscriptionPrice', 'annual'),
      label: 'Annual Subscription',
      initialized: p.price.annualInitialized,
    },
    onHelpClick: (url: string) => p.dispatch('onHelpClick', url),
  };
};

export const toCreator = (creator: GetInfluencerQuery['creator']): Creator => ({
  id: creator!.id,
  isLive: creator?.mode === Influencer.Mode.Live.value,
  isOnboarding: creator?.mode === Influencer.Mode.Onboarding.value,
  isExclusive: creator?.visibility === 'exclusive',
  offering: creator?.offering,
  subscriptionMonthlyPrice: creator?.subscriptionMonthlyPrice || null,
  subscriptionAnnualPrice: creator?.subscriptionAnnualPrice || null,
});
